var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reports-page" },
    [
      _c("pui-headline", { attrs: { type: "h1", "looks-like": "h3" } }, [
        _vm._v(" " + _vm._s(_vm.$t("generateErrorReport")) + " "),
      ]),
      !_vm.isRangeValid
        ? _c("pui-form-inline-notification", {
            staticClass: "reports-page__range-error-notification",
            attrs: {
              title: _vm.$t("reportRangeError.title"),
              text: _vm.$t("reportRangeError.message"),
              type: "error",
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "reports-page__filters" }, [
        _c(
          "div",
          { staticClass: "reports-page__filters__box" },
          _vm._l(_vm.processes, function (process, index) {
            return _c(
              "div",
              { key: index, staticClass: "reports-page__filters__box__option" },
              [
                _c("pui-form-checkbox", {
                  attrs: { label: _vm.$t(process.label), value: Number(index) },
                  on: { change: _vm.processesChanged },
                  model: {
                    value: _vm.selectedProcesses,
                    callback: function ($$v) {
                      _vm.selectedProcesses = $$v
                    },
                    expression: "selectedProcesses",
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "reports-page__filters__box" },
          _vm._l(_vm.subProcesses, function (subProcess, index) {
            return _c(
              "div",
              { key: index, staticClass: "reports-page__filters__box__option" },
              [
                _c("pui-form-checkbox", {
                  attrs: {
                    "is-disabled": _vm.checkIfSubprocessIsDisabled(
                      Number(index)
                    ),
                    label: _vm.$t(subProcess.label),
                    value: Number(index),
                  },
                  model: {
                    value: _vm.selectedSubProcesses,
                    callback: function ($$v) {
                      _vm.selectedSubProcesses = $$v
                    },
                    expression: "selectedSubProcesses",
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "reports-page__button" },
        [
          _c(
            "pui-button",
            {
              attrs: { disabled: _vm.exportDisabled },
              on: { click: _vm.exportReportsExcel },
            },
            [_vm._v(" " + _vm._s(_vm.$t("exportExcel")) + " ")]
          ),
        ],
        1
      ),
      _c("a", {
        ref: _vm.reportsExcelDownload,
        attrs: { href: _vm.reportsExcelUrl, download: _vm.reportsExcel.name },
      }),
      _c("pui-date-bottom-bar", {
        attrs: {
          range: _vm.range,
          "selectable-range": _vm.selectableRange,
          "options-selector-configuration": _vm.optionsSelectorConfiguration,
          "options-selector-model": _vm.optionsSelectorModel,
          "show-timezone": false,
        },
        on: {
          "update:optionsSelectorModel": function ($event) {
            _vm.optionsSelectorModel = $event
          },
          "update:options-selector-model": function ($event) {
            _vm.optionsSelectorModel = $event
          },
          "update:range": _vm.rangeChanged,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }